import api from '../utilities/api';
import { getCookie } from '../utilities/cookie';

const postProject = (id, data, service) => {
  return api.post(`${service}/editions/${id}/external-projects/`, data, {
    headers: { 'content-type': 'multipart/form-data' },
  });
};

const patchProject = (projectId, data, service) => {
  return api.patch(
    `${service}/projects/external-projects/${projectId}/edit/`,
    data,
    {
      headers: { 'content-type': 'multipart/form-data' },
    },
  );
};

const getMyProjects = (service, params) => {
  return api.get(`${service}/projects/user/${getCookie('mu_id')}/projects/`, {
    params: { ...params, title__contains: params?.search ?? '' },
  });
};

const getProject = (id, passUserId = true) => {
  return api.get(`/${service}/projects/external-projects/${id}/`, {
    params:
      getCookie('mu_id') && passUserId ? { mu_id: getCookie('mu_id') } : {},
  });
};

const deleteProject = (id, service = 'bo') => {
  return api.delete(
    `/${service}/projects/external-projects/${id}/${getCookie('mu_id')}/`,
  );
};

const getEditionForm = (id) => {
  return api.get(`/${service}/editions/${id}/form/`);
};

const getProjectForm = (projectId) => {
  return api.get(`/il/projects/${projectId}/form/`);
};

const getProjectsApproved = (
  editionId,
  { limit, page, ordering, search, filters },
) => {
  let tempOrdering = ordering;
  if (tempOrdering && tempOrdering.includes('sorted_number_integer')) {
    if (tempOrdering.includes('-')) {
      tempOrdering = '-sorted_abbreviation,-sorted_number_integer';
    } else {
      tempOrdering = 'sorted_abbreviation,sorted_number_integer';
    }
  }
  return api.get(`/${service}/editions/${editionId}/approved/external/`, {
    params: {
      limit,
      page,
      ordering: tempOrdering,
      title__contains: search,
      ...filters,
    },
  });
};

const getDistricts = () => {
  const url = new URL('https://gis.lublin.eu/ows2/');
  const params = {
    service: 'WFS',
    version: '1.0.0',
    outputFormat: 'application/json',
    request: 'GetFeature',
    typeName: 'geoportal:dzielnice',
    crs: 'EPSG:2179',
  };
  Object.keys(params).forEach((key) =>
    url.searchParams.append(key, params[key]),
  );
  return fetch(url, {
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'omit',
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  });
};

const getDistrict = (id) => {
  const url = new URL('https://gis.lublin.eu/ows2/');
  const params = {
    service: 'WFS',
    version: '1.0.0',
    outputFormat: 'application/json',
    request: 'GetFeature',
    typeName: 'geoportal:dzielnice',
    crs: 'EPSG:2179',
    property_name: 'id',
    featureid: `${id}`,
  };
  Object.keys(params).forEach((key) =>
    url.searchParams.append(key, params[key]),
  );
  return fetch(url, {
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'omit',
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  });
};

const getDistrictWithTimeout = (id, timeout = 5000) => {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new Error('TIMEOUT'));
    }, timeout);

    getDistrict(id)
      .then((response) => {
        clearTimeout(timer);
        resolve(response);
      })
      .catch((reason) => {
        clearTimeout(timer);
        reject(reason);
      });
  });
};

const getTrustedProfileRedirect = (returnUrl) => {
  return api.get('/bo/projects/wk-authentication/', {
    params: { return_url: returnUrl },
  });
};

const checkToken = (edition) => {
  return api.get('/bo/projects/wk-token-authentication/', {
    params: { edition },
  });
};

export {
  postProject,
  getMyProjects,
  getProject,
  getEditionForm,
  patchProject,
  getProjectsApproved,
  getProjectForm,
  getDistricts,
  getDistrict,
  deleteProject,
  getDistrictWithTimeout,
  getTrustedProfileRedirect,
  checkToken,
};
